export const oregon = {
  "41000": "Oregon",
  "41001": "Baker County",
  "41003": "Benton County",
  "41005": "Clackamas County",
  "41007": "Clatsop County",
  "41009": "Columbia County",
  "41011": "Coos County",
  "41013": "Crook County",
  "41015": "Curry County",
  "41017": "Deschutes County",
  "41019": "Douglas County",
  "41021": "Gilliam County",
  "41023": "Grant County",
  "41025": "Harney County",
  "41027": "Hood River County",
  "41029": "Jackson County",
  "41031": "Jefferson County",
  "41033": "Josephine County",
  "41035": "Klamath County",
  "41037": "Lake County",
  "41039": "Lane County",
  "41041": "Lincoln County",
  "41043": "Linn County",
  "41045": "Malheur County",
  "41047": "Marion County",
  "41049": "Morrow County",
  "41051": "Multnomah County",
  "41053": "Polk County",
  "41055": "Sherman County",
  "41057": "Tillamook County",
  "41059": "Umatilla County",
  "41061": "Union County",
  "41063": "Wallowa County",
  "41065": "Wasco County",
  "41067": "Washington County",
  "41069": "Wheeler County",
  "41071": "Yamhill County",
};
